<template>
  <card :id="`resource-component_${resourceType}-${meta.hasMany[name]}_list`" class="overflow-hidden border-0">
    <carousel :items-to-show="5" :wrap-around="false">
      <slide v-for="model in resource.data" :key="model">
        <Link
          :href="model.data.attributes[targetAttribute] ?? route(`${routePrefix}.${resourceType}.show`, model.data.id)"
          :style="{ background: 'url(\'' + model.data.attributes[imageAttribute] + '\') no-repeat center/cover' }"
          class="card video-card carousel__item d-flex text-decoration-none w-100 mx-1"
        >
          <div class="position-relative" style="margin-bottom: 7rem; background: rgba(0, 0, 0, 0.25)">
            <h2 class="mb-0 card-title">
              {{ model.data.attributes[titleAttribute] }}
            </h2>
          </div>
        </Link>
      </slide>

      <template #addons>
        <navigation />
        <pagination />
      </template>
    </carousel>
  </card>
</template>

<script>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel';
import Card from '@kanrisha/components/Base/Card';
import { Link } from '@inertiajs/vue3';
import useResource from '@kanrisha/composables/useResource';
import { ref } from 'vue';

export default {
  components: {
    Card,
    Carousel,
    Link,
    Navigation,
    Pagination,
    Slide,
  },
  props: {
    meta: { type: Object, default: () => {} },
    attributes: { type: Object, default: () => {} },
    resource: { type: Object, default: () => {} },
    options: { type: Object, default: () => {} },
    mode: { type: String, default: 'component' },
    name: { type: String, default: 'default' },
    pagination: { type: Boolean, default: () => true }, // not in use?
  },
  setup(props) {
    const { resourceType } = useResource(props, props.resource);
    const titleAttribute = ref(props.options.titleAttribute || 'title');
    const targetAttribute = ref(props.options.targetAttribute || null);
    const imageAttribute = ref(props.options.imageAttribute || null);

    return {
      resourceType,
      titleAttribute,
      targetAttribute,
      imageAttribute,
    };
  },
};
</script>
<style>
.carousel__prev {
  /*color: var(--primary-color);*/
  background: whitesmoke;
  transform: scale(2) translateY(-50%);
  border: 1px solid rgba(128, 128, 128, 0.6);
  border-radius: 2px;
}

.carousel__next {
  /*color: var(--primary-color);*/
  background: whitesmoke;
  transform: scale(2) translateY(-50%);
  border: 1px solid rgba(128, 128, 128, 0.6);
  border-radius: 2px;
}

.carousel__next--disabled, .carousel__prev--disabled {
  visibility: hidden;
}

.carousel__pagination {
  --vc-pgn-background-color: var(--tertiary-color);
  --vc-pgn-active-color: var(--primary-color);
  background: var(--tertiary-bg-color);
  padding-bottom: 0.75rem;
  position: relative;
  transform: scale(1.25);
  z-index: 1;
}
</style>
